var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutPot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 152,
    viewBox: "0 0 342 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.1 14.2901C172.206 19.9704 163.321 20.6742 163.321 20.6742C163.321 20.6742 160.774 12.1325 164.668 6.45225C168.563 0.771961 177.452 0.0883156 177.452 0.0883156C177.452 0.0883156 180.019 8.62617 176.124 14.3065L176.1 14.2901Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.378 0.0832075L163.25 20.6891C163.25 20.6891 172.139 20.0054 176.03 14.3051C179.924 8.6248 177.358 0.0869417 177.358 0.0869417L177.378 0.0832075Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.346 111.64H140.27L135.832 53.7461H205.783L201.346 111.64Z",
    fill: "#FF9A7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.346 111.64H140.27L135.832 53.7461H205.783L201.346 111.64Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.653 64.4306H204.963L205.783 53.7461H135.832L136.653 64.4306Z",
    fill: "#FF9A7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.653 64.4306H204.963L205.783 53.7461H135.832L136.653 64.4306Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.001 40.3652H128.999V54.4325H213.001V40.3652Z",
    fill: "#FF9A7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.001 40.3652H128.999V54.4325H213.001V40.3652Z",
    fill: "white",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 40,
    transform: "translate(0 111.641)",
    fill: "#9DC5C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPot2);
export default __webpack_public_path__ + "static/media/about_pot_2.7db1c07f81b7b63b944e5035c8f2b3bf.svg";
export { ForwardRef as ReactComponent };